import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DateInputValidationLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: ${({ theme }) => (theme.isError ? 'var(--color-error)' : 'var(--color-text)')};
`;

export const DateInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
`;

export const DateInputDropdown = styled.select`
  user-select: text;
  height: 56px;
  flex: 1;
  min-width: 0;

  appearance: none;

  padding: 15px 10px;

  background: rgba(173, 173, 173, 0.08);
  border-radius: 8px;
  outline: none;
  border: none;

  ${({ theme }) =>
    theme.isError &&
    `
    border: 1px solid var(--color-error) !important;
  `}

  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  color: var(--color-text);

  ${BREAKPOINTS.tablet} {
    font-size: 18px;
  }

  &:focus {
    border: 1px solid var(--color-data-company-background-hover);
  }

  ${({ disabled }) =>
    disabled &&
    `
    background: rgba(173, 173, 173, 0.3);
    border: 1px solid rgba(23, 28, 51, 0.5);
    color: #949494;
  `}

  option {
    background: var(--color-background);
    color: var(--color-text);
    padding: 8px;
  }

  option:disabled {
    color: rgba(23, 28, 51, 0.5);
  }

  cursor: pointer;
`;

export const DateInputPlaceholder = styled.option`
  color: rgba(23, 28, 51, 0.5);
  font-style: italic;
`;
